import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { State } from '@progress/kendo-data-query';
import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { isEmpty } from 'lodash';
import { useCallback, useId, useMemo, useState } from 'react';
import Button from 'src/components/design-system/Button';
import ExportExcel, { defaultExcelOption, ExcelOption } from 'src/components/ExportExcel';

export interface AttributesType {
  glCode: string;
  description: string;
  invoice: string;
  user: string;
}

interface ToolbarProps {
  clearFilter: () => void;
  dataState: State;
  rows: AttributesType[];
  allData: AttributesType[];
  excelExport: (data: AttributesType[]) => void;
}

const AttributesTableToolbar = ({
  clearFilter,
  dataState,
  excelExport,
  rows,
  allData,
}: ToolbarProps) => {
  const id = useId();
  const [excelOption, setExcelOption] = useState(defaultExcelOption);

  const handleExcelChange = useCallback(
    (e: DropDownListChangeEvent) => {
      const selectedOption: ExcelOption = e.target.value;
      setExcelOption(selectedOption);
      if (selectedOption.value === 1) {
        excelExport(rows);
        setExcelOption(defaultExcelOption);
      } else if (selectedOption.value === 2) {
        excelExport(allData);
        setExcelOption(defaultExcelOption);
      }
    },
    [allData, excelExport, rows]
  );

  const isFilterDisable = useMemo(
    () => isEmpty(dataState.filter?.filters),
    [dataState.filter?.filters]
  );

  return (
    <div className="flex items-center justify-between w-full">
      <Button
        onClick={clearFilter}
        disabled={isFilterDisable}
        className={isFilterDisable ? '!bg-transparent' : ''}
        endIcon={<FontAwesomeIcon icon={faCircleXmark} />}
        color="transparent"
        id={id}
      >
        Clear Filters
      </Button>

      <div className="flex flex-row gap-4">
        <ExportExcel excelOption={excelOption} onExcelChanged={handleExcelChange} width={200} />
      </div>
    </div>
  );
};

export default AttributesTableToolbar;
